module.exports = __webpack_public_path__ + "media/Kingfisher.9e4ed056.mp3";